// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Char from "../Data.Char/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_NonEmpty from "../Data.List.NonEmpty/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Data_Pitches_Internal from "../Data.Pitches.Internal/index.js";
import * as Data_Ring from "../Data.Ring/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as StringParser_CodePoints from "../StringParser.CodePoints/index.js";
import * as StringParser_Combinators from "../StringParser.Combinators/index.js";
import * as StringParser_Parser from "../StringParser.Parser/index.js";
import * as Test_QuickCheck_Arbitrary from "../Test.QuickCheck.Arbitrary/index.js";
import * as Test_QuickCheck_Gen from "../Test.QuickCheck.Gen/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var map = /* #__PURE__ */ Data_Functor.map(Test_QuickCheck_Gen.functorGen);
var arbitrary = /* #__PURE__ */ Test_QuickCheck_Arbitrary.arbitrary(Test_QuickCheck_Arbitrary.arbInt);
var power = /* #__PURE__ */ Data_Monoid.power(Data_Monoid.monoidString);
var abs = /* #__PURE__ */ Data_Ord.abs(Data_Ord.ordInt)(Data_Ring.ringInt);
var map1 = /* #__PURE__ */ Data_Functor.map(StringParser_Parser.functorParser);
var alt = /* #__PURE__ */ Control_Alt.alt(StringParser_Parser.altParser);
var div = /* #__PURE__ */ Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Ordering.eqOrdering);
var bind = /* #__PURE__ */ Control_Bind.bind(StringParser_Parser.bindParser);
var oneOf = /* #__PURE__ */ StringParser_CodePoints.oneOf(Data_Foldable.foldableArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(StringParser_Parser.applicativeParser);
var compare1 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordInt));
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showChar);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(StringParser_Parser.bindParser);
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var writeImpl = /* #__PURE__ */ Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
var SInterval = function (x) {
    return x;
};
var SIC = function (x) {
    return x;
};
var Acc = function (x) {
    return x;
};
var toMidiSInterval = {
    toMidi: function (v) {
        return (v.fifths * 7 | 0) + (v.octaves * 12 | 0) | 0;
    }
};
var toMidi = /* #__PURE__ */ Data_Pitches_Class.toMidi(toMidiSInterval);
var toMidiSIC = {
    toMidi: function (v) {
        return mod(v * 7 | 0)(12);
    }
};
var toMidi1 = /* #__PURE__ */ Data_Pitches_Class.toMidi(toMidiSIC);
var toMidiPitchSInterval = {
    toMidiPitch: function (i) {
        return toMidi(i) + 12 | 0;
    }
};
var toMidiPitchSIC = {
    toMidiPitch: function (i) {
        return toMidi1(i) + 60 | 0;
    }
};
var eqSInterval = {
    eq: function (x) {
        return function (y) {
            return x.fifths === y.fifths && x.octaves === y.octaves;
        };
    }
};
var eqSIC = {
    eq: function (x) {
        return function (y) {
            return x === y;
        };
    }
};
var ordSIC = {
    compare: function (x) {
        return function (y) {
            return compare(x)(y);
        };
    },
    Eq0: function () {
        return eqSIC;
    }
};
var arbitrarySIC = {
    arbitrary: /* #__PURE__ */ map(function ($264) {
        return SIC((function (v) {
            return mod(v)(100);
        })($264));
    })(arbitrary)
};
var spelled = function (fifths1) {
    return function (octaves3) {
        return {
            fifths: fifths1,
            octaves: octaves3
        };
    };
};
var spelledp = function (fs) {
    return function (os) {
        return spelled(fs)(os);
    };
};
var wholetone = /* #__PURE__ */ (function () {
    return spelled(2)(-1 | 0);
})();
var arbitrarySInterval = {
    arbitrary: /* #__PURE__ */ Control_Apply.apply(Test_QuickCheck_Gen.applyGen)(/* #__PURE__ */ map(spelled)(/* #__PURE__ */ map(function (v) {
        return mod(v)(100);
    })(arbitrary)))(/* #__PURE__ */ map(function (v) {
        return mod(v)(100);
    })(arbitrary))
};
var semigroupSInterval = {
    append: function (v) {
        return function (v1) {
            return spelled(v.fifths + v1.fifths | 0)(v.octaves + v1.octaves | 0);
        };
    }
};
var append1 = /* #__PURE__ */ Data_Semigroup.append(semigroupSInterval);
var monoidSInterval = {
    mempty: /* #__PURE__ */ spelled(0)(0),
    Semigroup0: function () {
        return semigroupSInterval;
    }
};
var groupSInterval = {
    ginverse: function (v) {
        return spelled(-v.fifths | 0)(-v.octaves | 0);
    },
    Monoid0: function () {
        return monoidSInterval;
    }
};
var sic = SIC;
var spc = function (fs) {
    return sic(fs);
};
var tritone$prime = /* #__PURE__ */ sic(6);
var semigroupSIC = {
    append: function (v) {
        return function (v1) {
            return sic(v + v1 | 0);
        };
    }
};
var monoidSIC = {
    mempty: /* #__PURE__ */ sic(0),
    Semigroup0: function () {
        return semigroupSIC;
    }
};
var groupSIC = {
    ginverse: function (v) {
        return sic(-v | 0);
    },
    Monoid0: function () {
        return monoidSIC;
    }
};
var shp = 1;
var qualpf = function (n) {
    return function (la) {
        return function (lp) {
            return function (ld) {
                if (n > 0) {
                    return power(la)(n);
                };
                if (n === 0) {
                    return lp;
                };
                if (Data_Boolean.otherwise) {
                    return power(ld)(abs(n));
                };
                throw new Error("Failed pattern match at Data.Pitches.Spelled (line 218, column 1 - line 218, column 54): " + [ n.constructor.name, la.constructor.name, lp.constructor.name, ld.constructor.name ]);
            };
        };
    };
};
var qualimpf = function (n) {
    return function (la) {
        return function (lmj) {
            return function (lmn) {
                return function (ld) {
                    if (n > 0) {
                        return power(la)(n);
                    };
                    if (n === 0) {
                        return lmj;
                    };
                    if (n === (-1 | 0)) {
                        return lmn;
                    };
                    if (Data_Boolean.otherwise) {
                        return power(ld)((-n | 0) - 1 | 0);
                    };
                    throw new Error("Failed pattern match at Data.Pitches.Spelled (line 224, column 1 - line 224, column 66): " + [ n.constructor.name, la.constructor.name, lmj.constructor.name, lmn.constructor.name, ld.constructor.name ]);
                };
            };
        };
    };
};
var parseAccs = /* #__PURE__ */ (function () {
    var munch = function ($265) {
        return StringParser_Combinators.many1(StringParser_CodePoints["char"]($265));
    };
    var sharps = map1(Data_List_NonEmpty.length)(alt(munch("\u266f"))(munch("#")));
    var flats = map1(function ($266) {
        return -Data_List_NonEmpty.length($266) | 0;
    })(alt(munch("\u266d"))(munch("b")));
    return StringParser_Combinators.option(0)(alt(sharps)(flats));
})();
var octaves = function (dict) {
    return dict.octaves;
};
var nat = 0;
var isPerfect = function (v) {
    if (v === 0) {
        return true;
    };
    if (v === 3) {
        return true;
    };
    if (v === 4) {
        return true;
    };
    return false;
};
var internalOctaves = function (dict) {
    return dict.internalOctaves;
};
var generic = function (dict) {
    return dict.generic;
};
var fourth$prime = /* #__PURE__ */ (function () {
    return sic(-1 | 0);
})();
var fourth = /* #__PURE__ */ (function () {
    return spelled(-1 | 0)(1);
})();
var flt = /* #__PURE__ */ (function () {
    return -1 | 0;
})();
var fifths2degree = function (fifths1) {
    return mod(fifths1 * 4 | 0)(7);
};
var spelledSIC = {
    fifths: function (v) {
        return v;
    },
    octaves: function (v) {
        return 0;
    },
    internalOctaves: function (v) {
        return 0;
    },
    degree: function (v) {
        return fifths2degree(v);
    },
    generic: function (v) {
        return fifths2degree(v);
    },
    diasteps: function (v) {
        return fifths2degree(v);
    },
    alteration: function (v) {
        return div(v + 1 | 0)(7);
    }
};
var fifths = function (dict) {
    return dict.fifths;
};
var fifth$prime = /* #__PURE__ */ sic(1);
var fifth = /* #__PURE__ */ spelled(1)(0);
var diasteps = function (dict) {
    return dict.diasteps;
};
var diasteps1 = /* #__PURE__ */ diasteps(spelledSIC);
var intervalSIC = {
    octave: /* #__PURE__ */ sic(0),
    direction: function (i) {
        var dia = diasteps1(i);
        var $226 = dia === 0;
        if ($226) {
            return Data_Ordering.EQ.value;
        };
        var $227 = dia < 4;
        if ($227) {
            return Data_Ordering.GT.value;
        };
        return Data_Ordering.LT.value;
    },
    Group0: function () {
        return groupSIC;
    }
};
var iminus = /* #__PURE__ */ Data_Pitches_Class.iminus(intervalSIC);
var pplusi = /* #__PURE__ */ Data_Pitches_Class.pplusi(intervalSIC);
var itimes = /* #__PURE__ */ Data_Pitches_Class.itimes(intervalSIC);
var down = /* #__PURE__ */ Data_Pitches_Class.down(intervalSIC);
var second$prime = function (v) {
    return iminus(sic(2))(v);
};
var seventh$prime = function (v) {
    return iminus(sic(5))(v);
};
var sixth$prime = function (v) {
    return iminus(sic(3))(v);
};
var third$prime = function (v) {
    return iminus(sic(4))(v);
};
var chromaticSIC = {
    chromaticSemitone: /* #__PURE__ */ sic(7),
    Interval0: function () {
        return intervalSIC;
    }
};
var chromaticSemitone = /* #__PURE__ */ Data_Pitches_Class.chromaticSemitone(chromaticSIC);
var toSPC = function (fs) {
    return function (v) {
        return pplusi(spc(fs))(itimes(chromaticSemitone)(v));
    };
};
var e$prime = /* #__PURE__ */ toSPC(4);
var f$prime = /* #__PURE__ */ (function () {
    return toSPC(-1 | 0);
})();
var g$prime = /* #__PURE__ */ toSPC(1);
var hasIntervalClassSICSIC = {
    ic: function (i) {
        return i;
    },
    Interval0: function () {
        return intervalSIC;
    },
    Interval1: function () {
        return intervalSIC;
    }
};
var degree = function (dict) {
    return dict.degree;
};
var degree1 = /* #__PURE__ */ degree(spelledSIC);
var diatonicSIC = {
    isStep: function (i) {
        var deg = degree1(i);
        return deg === 0 || (deg === 1 || deg === 6);
    },
    Interval0: function () {
        return intervalSIC;
    }
};
var spelledSInterval = {
    fifths: function (v) {
        return v.fifths;
    },
    octaves: function (v) {
        return v.octaves + div(v.fifths * 4 | 0)(7) | 0;
    },
    internalOctaves: function (v) {
        return v.octaves;
    },
    degree: function (v) {
        return fifths2degree(v.fifths);
    },
    generic: function (i) {
        if (eq1(Data_Pitches_Class.direction(intervalSInterval)(i))(Data_Ordering.LT.value)) {
            return -degree(spelledSInterval)(Data_Pitches_Class.down(intervalSInterval)(i)) | 0;
        };
        if (Data_Boolean.otherwise) {
            return degree(spelledSInterval)(i);
        };
        throw new Error("Failed pattern match at Data.Pitches.Spelled (line 346, column 1 - line 355, column 47): " + [ i.constructor.name ]);
    },
    diasteps: function (v) {
        return (v.fifths * 4 | 0) + (v.octaves * 7 | 0) | 0;
    },
    alteration: function (i) {
        return div(fifths(spelledSInterval)(Data_Pitches_Class.iabs(intervalSInterval)(i)) + 1 | 0)(7);
    }
};
var intervalSInterval = {
    octave: /* #__PURE__ */ spelled(0)(1),
    direction: function (i) {
        return compare(diasteps(spelledSInterval)(i))(0);
    },
    Group0: function () {
        return groupSInterval;
    }
};
var iminus1 = /* #__PURE__ */ Data_Pitches_Class.iminus(intervalSInterval);
var itimes1 = /* #__PURE__ */ Data_Pitches_Class.itimes(intervalSInterval);
var pplusi1 = /* #__PURE__ */ Data_Pitches_Class.pplusi(intervalSInterval);
var diasteps2 = /* #__PURE__ */ diasteps(spelledSInterval);
var down1 = /* #__PURE__ */ Data_Pitches_Class.down(intervalSInterval);
var direction = /* #__PURE__ */ Data_Pitches_Class.direction(intervalSInterval);
var octaves1 = /* #__PURE__ */ octaves(spelledSInterval);
var degree2 = /* #__PURE__ */ degree(spelledSInterval);
var second = function (v) {
    return iminus1(spelled(2)(-1 | 0))(v);
};
var seventh = function (v) {
    return iminus1(spelled(5)(-2 | 0))(v);
};
var sixth = function (v) {
    return iminus1(spelled(3)(-1 | 0))(v);
};
var third = function (v) {
    return iminus1(spelled(4)(-2 | 0))(v);
};
var chromaticSInterval = /* #__PURE__ */ (function () {
    return {
        chromaticSemitone: spelled(7)(-4 | 0),
        Interval0: function () {
            return intervalSInterval;
        }
    };
})();
var chromaticSemitone1 = /* #__PURE__ */ Data_Pitches_Class.chromaticSemitone(chromaticSInterval);
var onlyDia = function (n) {
    return iminus1(itimes1(wholetone)(n))(itimes1(chromaticSemitone1)(2 * n | 0));
};
var spelledDiaChrom = function (dia) {
    return function (chrom) {
        var diaPart = itimes1(wholetone)(dia);
        var chromPart = itimes1(chromaticSemitone1)(chrom - (2 * dia | 0) | 0);
        return append1(diaPart)(chromPart);
    };
};
var toSpelled = function (fs) {
    return function (os) {
        return function (v) {
            return function (oct) {
                return pplusi1(spelledp(fs)(os + oct | 0))(itimes1(chromaticSemitone1)(v));
            };
        };
    };
};
var e = /* #__PURE__ */ (function () {
    return toSpelled(4)(-2 | 0);
})();
var f = /* #__PURE__ */ (function () {
    return toSpelled(-1 | 0)(1);
})();
var g = /* #__PURE__ */ toSpelled(1)(0);
var tritone = /* #__PURE__ */ Data_Pitches_Class.aug(chromaticSInterval)(fourth);
var diatonicSInterval = {
    isStep: function (i) {
        return abs(diasteps2(i)) < 2;
    },
    Interval0: function () {
        return intervalSInterval;
    }
};
var hasIntervalClassSInterval = {
    ic: function (v) {
        return sic(v.fifths);
    },
    Interval0: function () {
        return intervalSInterval;
    },
    Interval1: function () {
        return intervalSIC;
    }
};
var hasIntervalSICSInterval = {
    emb: function (v) {
        return spelled(v)(-div(v * 4 | 0)(7) | 0);
    },
    Interval0: function () {
        return intervalSInterval;
    },
    Interval1: function () {
        return intervalSIC;
    }
};
var hasIntervalSIntervalSInte = {
    emb: function (i) {
        return i;
    },
    Interval0: function () {
        return intervalSInterval;
    },
    Interval1: function () {
        return intervalSInterval;
    }
};
var d$prime = /* #__PURE__ */ toSPC(2);
var d = /* #__PURE__ */ (function () {
    return toSpelled(2)(-1 | 0);
})();
var c$prime = /* #__PURE__ */ toSPC(0);
var c = /* #__PURE__ */ toSpelled(0)(0);
var b$prime = /* #__PURE__ */ toSPC(5);
var b = /* #__PURE__ */ (function () {
    return toSpelled(5)(-2 | 0);
})();
var asciiA = /* #__PURE__ */ Data_Char.toCharCode("A");
var letter = function (dictSpelled) {
    var degree3 = degree(dictSpelled);
    return function (i) {
        return Data_String_CodePoints.singleton(Data_String_CodePoints.codePointFromChar(Data_Maybe.fromMaybe("X")(Data_Char.fromCharCode(asciiA + mod(degree3(i) + 2 | 0)(7) | 0))));
    };
};
var parseName = /* #__PURE__ */ bind(/* #__PURE__ */ oneOf([ "A", "B", "C", "D", "E", "F", "G" ]))(function (name) {
    var dia = mod((Data_Char.toCharCode(name) - asciiA | 0) - 2 | 0)(7);
    return bind(parseAccs)(function (acc) {
        return pure((mod((dia * 2 | 0) + 1 | 0)(7) - 1 | 0) + (7 * acc | 0) | 0);
    });
});
var alteration = function (dict) {
    return dict.alteration;
};
var alteration1 = /* #__PURE__ */ alteration(spelledSInterval);
var alteration2 = /* #__PURE__ */ alteration(spelledSIC);
var ordSInterval = {
    compare: function (i1) {
        return function (i2) {
            return compare1([ diasteps2(i1), alteration1(i1) ])([ diasteps2(i2), alteration1(i2) ]);
        };
    },
    Eq0: function () {
        return eqSInterval;
    }
};
var spelledPitch = function (dictSpelled) {
    var fifths1 = fifths(dictSpelled);
    var octaves3 = octaves(dictSpelled);
    var internalOctaves1 = internalOctaves(dictSpelled);
    var degree3 = degree(dictSpelled);
    return function (dictHasIntervalClass) {
        var ic = Data_Pitches_Class.ic(dictHasIntervalClass);
        return function (dictSpelled1) {
            var alteration5 = alteration(dictSpelled1);
            return {
                fifths: function (v) {
                    return fifths1(v);
                },
                octaves: function (v) {
                    return octaves3(v);
                },
                internalOctaves: function (v) {
                    return internalOctaves1(v);
                },
                degree: function (v) {
                    return degree3(v);
                },
                generic: function (v) {
                    return degree3(v);
                },
                diasteps: function (v) {
                    return degree3(v);
                },
                alteration: function (v) {
                    return alteration5(ic(v));
                }
            };
        };
    };
};
var spelledPitch1 = /* #__PURE__ */ spelledPitch(spelledSIC)(hasIntervalClassSICSIC)(spelledSIC);
var alteration3 = /* #__PURE__ */ alteration(spelledPitch1);
var letter1 = /* #__PURE__ */ letter(spelledPitch1);
var spelledPitch2 = /* #__PURE__ */ spelledPitch(spelledSInterval)(hasIntervalClassSInterval)(spelledSIC);
var alteration4 = /* #__PURE__ */ alteration(spelledPitch2);
var letter2 = /* #__PURE__ */ letter(spelledPitch2);
var octaves2 = /* #__PURE__ */ octaves(spelledPitch2);
var altQual = /* #__PURE__ */ bind(/* #__PURE__ */ oneOf([ "M", "P", "m" ]))(function (qual) {
    if (qual === "P") {
        return pure(function (pf) {
            if (pf) {
                return pure(0);
            };
            return StringParser_Parser.fail("used P on an imperfect interval");
        });
    };
    if (qual === "M") {
        return pure(function (pf) {
            if (pf) {
                return StringParser_Parser.fail("used M on a perfect interval");
            };
            return pure(0);
        });
    };
    if (qual === "m") {
        return pure(function (pf) {
            if (pf) {
                return StringParser_Parser.fail("used m on a perfect interval");
            };
            return pure(-1 | 0);
        });
    };
    return StringParser_Parser.fail("unknown qualifier " + show(qual));
});
var altDim = /* #__PURE__ */ bind(/* #__PURE__ */ StringParser_Combinators.many1(/* #__PURE__ */ StringParser_CodePoints["char"]("d")))(function (ds) {
    return pure(function (pf) {
        return pure((-Data_List_NonEmpty.length(ds) | 0) - (function () {
            if (pf) {
                return 0;
            };
            return 1;
        })() | 0);
    });
});
var altAug = /* #__PURE__ */ bind(/* #__PURE__ */ StringParser_Combinators.many1(/* #__PURE__ */ StringParser_CodePoints["char"]("a")))(function (as) {
    return pure(function (v) {
        return pure(Data_List_NonEmpty.length(as));
    });
});
var parseDia = /* #__PURE__ */ bind(/* #__PURE__ */ alt(altAug)(/* #__PURE__ */ alt(altDim)(altQual)))(function (falt) {
    return bind(map1(function (x) {
        return x - 1 | 0;
    })(Data_Pitches_Internal.parseUInt))(function (dia) {
        return bind(falt(isPerfect(dia)))(function (alt1) {
            return pure((mod((dia * 2 | 0) + 1 | 0)(7) - 1 | 0) + (7 * alt1 | 0) | 0);
        });
    });
});
var notationSIC = {
    parseNotation: function (str) {
        var parser = bind(StringParser_Combinators.option("+")(StringParser_CodePoints["char"]("-")))(function (sign) {
            return bind(map1(sic)(parseDia))(function (i) {
                return discard(StringParser_CodePoints.eof)(function () {
                    return pure((function () {
                        var $256 = sign === "-";
                        if ($256) {
                            return down(i);
                        };
                        return i;
                    })());
                });
            });
        });
        return Data_Either.hush(StringParser_Parser.runParser(parser)(str));
    },
    showNotation: function (i) {
        var dia = diasteps1(i);
        var alt1 = alteration2(i);
        var qual = (function () {
            var $257 = isPerfect(dia);
            if ($257) {
                return qualpf(alt1)("a")("P")("d");
            };
            return qualimpf(alt1)("a")("M")("m")("d");
        })();
        return qual + show1(dia + 1 | 0);
    }
};
var readJSONviaParse = /* #__PURE__ */ Data_Pitches_Internal.readJSONviaParse(notationSIC);
var showNotation = /* #__PURE__ */ Data_Pitches_Class.showNotation(notationSIC);
var parseSIC = /* #__PURE__ */ Data_Pitches_Class.parseNotation(notationSIC);
var readForeignSIC = {
    readImpl: function (input) {
        return readJSONviaParse("spelled interval class")(input);
    }
};
var showSIC = {
    show: showNotation
};
var writeForeignSIC = {
    writeImpl: function ($267) {
        return writeImpl(showNotation($267));
    }
};
var notationSInterval = {
    parseNotation: function (str) {
        var parser = bind(StringParser_Combinators.option("+")(StringParser_CodePoints["char"]("-")))(function (sign) {
            return bind(parseDia)(function (fs) {
                return bind(StringParser_CodePoints["char"](":"))(function () {
                    return bind(Data_Pitches_Internal.parseSInt)(function (os) {
                        return discard(StringParser_CodePoints.eof)(function () {
                            var i = {
                                fifths: fs,
                                octaves: os - div(fs * 4 | 0)(7) | 0
                            };
                            return pure((function () {
                                var $258 = sign === "-";
                                if ($258) {
                                    return down1(i);
                                };
                                return i;
                            })());
                        });
                    });
                });
            });
        });
        return Data_Either.hush(StringParser_Parser.runParser(parser)(str));
    },
    showNotation: function (i) {
        if (eq1(direction(i))(Data_Ordering.LT.value)) {
            return "-" + Data_Show.show($lazy_showSInterval(0))(down1(i));
        };
        if (Data_Boolean.otherwise) {
            var octs = show1(octaves1(i));
            var deg = degree2(i);
            var dia = show1(deg + 1 | 0);
            var alt1 = alteration1(i);
            var qual = (function () {
                var $260 = isPerfect(deg);
                if ($260) {
                    return qualpf(alt1)("a")("P")("d");
                };
                return qualimpf(alt1)("a")("M")("m")("d");
            })();
            return qual + (dia + (":" + octs));
        };
        throw new Error("Failed pattern match at Data.Pitches.Spelled (line 685, column 1 - line 713, column 32): " + [ i.constructor.name ]);
    }
};
var $lazy_showSInterval = /* #__PURE__ */ $runtime_lazy("showSInterval", "Data.Pitches.Spelled", function () {
    return {
        show: Data_Pitches_Class.showNotation(notationSInterval)
    };
});
var showSInterval = /* #__PURE__ */ $lazy_showSInterval(388);
var parseSpelled = /* #__PURE__ */ Data_Pitches_Class.parseNotation(notationSInterval);
var readForeignSInterval = {
    readImpl: /* #__PURE__ */ Data_Pitches_Internal.readJSONviaParse(notationSInterval)("spelled interval")
};
var writeForeignSInterval = {
    writeImpl: /* #__PURE__ */ (function () {
        var $268 = Data_Pitches_Class.showNotation(notationSInterval);
        return function ($269) {
            return writeImpl($268($269));
        };
    })()
};
var accstr = function (n) {
    return function (lu) {
        return function (ld) {
            if (n === 0) {
                return "";
            };
            if (n > 0) {
                return power(lu)(n);
            };
            if (Data_Boolean.otherwise) {
                return power(ld)(abs(n));
            };
            throw new Error("Failed pattern match at Data.Pitches.Spelled (line 212, column 1 - line 212, column 44): " + [ n.constructor.name, lu.constructor.name, ld.constructor.name ]);
        };
    };
};
var notationPitchSIC = {
    parsePitchNotation: function (str) {
        var parser = bind(parseName)(function (fifths1) {
            return discard(StringParser_CodePoints.eof)(function () {
                return pure(sic(fifths1));
            });
        });
        return Data_Either.hush(StringParser_Parser.runParser(parser)(str));
    },
    showPitchNotation: function (i) {
        var accs = accstr(alteration3(i))("\u266f")("\u266d");
        return letter1(i) + accs;
    }
};
var notationPitch = /* #__PURE__ */ Data_Pitches_Class.notationPitch(notationPitchSIC);
var readJSONviaParse1 = /* #__PURE__ */ Data_Pitches_Internal.readJSONviaParse(notationPitch);
var showNotation1 = /* #__PURE__ */ Data_Pitches_Class.showNotation(notationPitch);
var parseSPC = /* #__PURE__ */ Data_Pitches_Class.parseNotation(notationPitch);
var readForeignPitchSIC = {
    readImplPitch: function (input) {
        return readJSONviaParse1("spelled pitch class")(input);
    }
};
var writeForeignPitchSIC = {
    writeImplPitch: function (i) {
        return writeImpl(showNotation1(i));
    }
};
var notationPitchSInterval = {
    parsePitchNotation: function (str) {
        var parser = bind(parseName)(function (fs) {
            return bind(Data_Pitches_Internal.parseSInt)(function (os) {
                return discard(StringParser_CodePoints.eof)(function () {
                    return pure(spelled(fs)(os - div(fs * 4 | 0)(7) | 0));
                });
            });
        });
        return Data_Either.hush(StringParser_Parser.runParser(parser)(str));
    },
    showPitchNotation: function (i) {
        var accs = accstr(alteration4(i))("\u266f")("\u266d");
        return letter2(i) + (accs + show1(octaves2(i)));
    }
};
var notationPitch1 = /* #__PURE__ */ Data_Pitches_Class.notationPitch(notationPitchSInterval);
var readJSONviaParse2 = /* #__PURE__ */ Data_Pitches_Internal.readJSONviaParse(notationPitch1);
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Pitches_Class.showPitch(notationPitchSInterval));
var parseSpelledP = /* #__PURE__ */ Data_Pitches_Class.parseNotation(notationPitch1);
var readForeignPitchSInterval = {
    readImplPitch: function (input) {
        return readJSONviaParse2("spelled pitch")(input);
    }
};
var writeForeignPitchSInterva = {
    writeImplPitch: function (i) {
        return writeImpl(show2(i));
    }
};
var a$prime = /* #__PURE__ */ toSPC(3);
var a = /* #__PURE__ */ (function () {
    return toSpelled(3)(-1 | 0);
})();
export {
    fifths,
    octaves,
    internalOctaves,
    degree,
    generic,
    diasteps,
    alteration,
    SInterval,
    parseSpelled,
    spelled,
    spelledDiaChrom,
    onlyDia,
    wholetone,
    second,
    third,
    fourth,
    tritone,
    fifth,
    sixth,
    seventh,
    SIC,
    parseSIC,
    sic,
    second$prime,
    third$prime,
    fourth$prime,
    tritone$prime,
    fifth$prime,
    sixth$prime,
    seventh$prime,
    letter,
    flt,
    nat,
    shp,
    parseSpelledP,
    spelledp,
    a,
    b,
    c,
    d,
    e,
    f,
    g,
    parseSPC,
    spc,
    a$prime,
    b$prime,
    c$prime,
    d$prime,
    e$prime,
    f$prime,
    g$prime,
    eqSInterval,
    arbitrarySInterval,
    spelledSInterval,
    semigroupSInterval,
    monoidSInterval,
    groupSInterval,
    ordSInterval,
    intervalSInterval,
    hasIntervalClassSInterval,
    hasIntervalSIntervalSInte,
    diatonicSInterval,
    chromaticSInterval,
    toMidiSInterval,
    showSInterval,
    writeForeignSInterval,
    readForeignSInterval,
    eqSIC,
    ordSIC,
    arbitrarySIC,
    spelledSIC,
    semigroupSIC,
    monoidSIC,
    groupSIC,
    intervalSIC,
    hasIntervalSICSInterval,
    hasIntervalClassSICSIC,
    diatonicSIC,
    chromaticSIC,
    toMidiSIC,
    showSIC,
    writeForeignSIC,
    readForeignSIC,
    spelledPitch,
    writeForeignPitchSInterva,
    readForeignPitchSInterval,
    toMidiPitchSInterval,
    writeForeignPitchSIC,
    readForeignPitchSIC,
    toMidiPitchSIC,
    notationSInterval,
    notationSIC,
    notationPitchSInterval,
    notationPitchSIC
};
